import { formatDate } from '@angular/common';

export interface MancosToCheckUpOn {
  nrOfMancos: number;
  mancos: MancoToCheckUpOn[];
}
export interface Manco {
  caseNumber: string | null;
  customerNumber: string | null;
  forOrderNumber: string | null;
  mancoOrderNumber: string | null;
  ticketNumber: string | null;
  note?: string | null;
  returnNumber?: string | null;
  treatmentDate: string;
  checkDate: string;
  booked: boolean;
  completed: boolean;
  returnReceived: boolean;
}
export interface MancoToCheckUpOn extends Manco {
  id: number;
  createdAt: Date;
  createdBy: string | null;
  updatedAt: Date;
  updatedBy: string | null;
}
export interface MancoToAdd extends Manco {
  createdByHint: string;
}
export interface MancoToUpdate extends Manco {
  updatedByHint: string;
}
export interface AddedMancoId {
  id: string;
}

export const EmptyMancoToCheckUpOn = (): Manco => ({
  ticketNumber: '',
  customerNumber: '',
  forOrderNumber: '',
  mancoOrderNumber: '',
  caseNumber: '',
  note: '',
  returnNumber: '',
  treatmentDate: formatDate(new Date(), 'yyyy-MM-dd', 'nl-NL'),
  checkDate: formatDate(new Date().setDate(new Date().getDate() + 14), 'yyyy-MM-dd', 'nl-NL'),
  booked: false,
  completed: false,
  returnReceived: false,
});
